import Sveip from '@nrk/dh-basis-sveip'
import { connectScrollContainerLazyLoad } from '@nrk/dh-basis-common'
import styles from './bildesveip.module.css'

export default class Bildesveip extends Sveip {
  connectedCallback() {
    super.connectedCallback()

    window.addEventListener('resize', this.verticalAlignImages)
    window.addEventListener('load', this.verticalAlignImages)
    this.mediaElements.forEach((img) => {
      img.addEventListener('load', this.verticalAlignImages)
    })

    this._disconnectLazyLoad = connectScrollContainerLazyLoad(
      this.scrollContainer,
      this.querySelectorAll('img'),
    )

    setTimeout(this.verticalAlignImages, 100)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('resize', this.verticalAlignImages)
    window.removeEventListener('load', this.verticalAlignImages)
    this.mediaElements.forEach((img) => {
      img.removeEventListener('load', this.verticalAlignImages)
    })
    this._disconnectLazyLoad()
  }

  /**
   * Vertical aligns each image, and sets local css prop --_img-max-height to align buttons
   */
  verticalAlignImages = () => {
    // Read before write to avoid thrashing
    const elements = this.mediaElements
    const heights = elements.map((el) => el.getBoundingClientRect().height)
    const maxHeight = Math.max(...heights)

    //  Write values once we have all bounding rectangles
    for (let i = 0; i < elements.length; i++) {
      const marginTop = Math.max((maxHeight - heights[i]) / 2, 0)
      elements[i].style.setProperty('margin-top', `${marginTop}px`)
    }

    if (maxHeight > 20) {
      this.style.setProperty('--_img-max-height', `${maxHeight}px`)
    }
  }

  get mediaElements() {
    return this.items.map((item) => item.querySelector(`img, .${styles.media}`))
  }

  set offsetRules(val) {
    // TODO: Remove once clients are updated
  }

  get offsetRules() {
    return []
  }
}
